/* eslint-disable array-callback-return */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import stripHtml from "string-strip-html";
// import { throttle, debounce } from "throttle-debounce";

class MessageInput extends Component {
  state = {
    message: "",
    isTyping: false,
  };
  _isMounted = false;
  lastUpdateTime = "";

  handleSubmit = (e) => {
    e.preventDefault();
    this.sendMessage("message");
    this.setState({
      message: "",
    });
  };
  sendMessage = (gubun) => {
    const { message } = this.state;
    if (message === "" || message === null || message === undefined) {
    } else {
      this.props.childProps.sendMessage(message, gubun);
    }
  };
  componentDidMount = () => {
    this._isMounted = true;
    /*
        const {user, sendMessage } = this.props.childProps;
        //console.log('입장멘트')
        //console.log(user)
        sendMessage(user.name + '님이 입장하셨습니다.')
        */
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    this.stopCheckingTyping();
  };

  sendTyping = () => {
    this.lastUpdateTime = Date.now();
    if (!this.state.isTyping) {
      if (this._isMounted) {
        this.setState({
          isTyping: true,
        });

        this.props.childProps.sendTyping(true);
        this.startCheckingTyping();
      }
    }
  };
  startCheckingTyping = () => {
    //console.log("Typing")
    this.typingInterval = setInterval(() => {
      if (Date.now() - this.lastUpdateTime > 300) {
        if (this._isMounted) {
          this.setState({
            isTyping: false,
          });
          this.stopCheckingTyping();
        }
      }
    }, 300);
  };

  stopCheckingTyping = () => {
    //console.log("stop Typing")
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
      this.props.childProps.sendTyping(false);
    }
  };
  _emoticon = () => {
    //this.messageinput.value = '<img src="/img/live_img/19.png" />'
    // const { message } = this.state;
    if (this._isMounted) {
      this.setState({
        message:
          '<img src="/img/live_img/img_test50.png" style="width: 91px; height: 98px"/>',
      });
    }

    setTimeout((e) => {
      this.sendMessage("emoticon");
      if (this._isMounted) {
        this.setState({
          message: "",
        });
      }
    }, 10);
  };
  _onMessageChange = (e) => {
    e.persist();

    const filterWords = [
      "개새끼",
      "씨팔",
      "좆까",
      "시발놈",
      "병신",
      "호로새끼",
      "빙신",
      "개새",
      "씹새",
      "씹세",
      "뻑큐",
      "fuck",
    ];

    //console.log(e.target.value)

    let message = e.target.value.replace(/<[^>]+>/g, "");

    let matchCnt = 0;
    filterWords.map((item, index) => {
      let compare = message.match(item);
      //console.log(compare)
      if (compare) {
        if (compare.index >= 0) {
          //console.log(message)
          alert("금지어가 포함되어 있습니다.[" + item + "]");
          //message.replace(item, '')
          matchCnt++;
          ////console.log(message)
        }
      }
    });

    //console.log(matchCnt)
    /*
        const message = stripHtml(e.target.value, {
            ignoreTags: [' '],
            onlyStripTags: [],
            stripTogetherWithTheirContents: ["script", "style", "xml"],
            skipHtmlDecoding: false,
            returnRangesOnly: false,
            trimOnlySpaces: false,
            dumpLinkHrefsNearby: {
                enabled: false,
                putOnNewLine: false,
                wrapHeads: "",
                wrapTails: ""
            }
            }
        )
        */
    ////console.log(message)

    if (matchCnt > 0) {
      //alert('금지어가 포함되어 있습니다.')
    } else if (matchCnt === 0) {
      if (this._isMounted) {
        this.setState({
          message: message,
        });
      }
    }
  };
  _onSendClick = () => {
    this.sendMessage("message");
    this.setState({
      message: "",
    });
  };
  render() {
    const { loginId } = this.props;
    const { message } = this.state;
    return (
      <Fragment>
        {loginId === "" || loginId === null || loginId === undefined ? (
          <Fragment>
            {/*
                    <div className="chatting_icon">
                        <div className="div_ul">
                            
                        </div>
                    </div>
                    <div className="chatting_input">
                        <p>채팅에 참여하시려면 로그인 해주세요.</p>
                    </div>
                    */}
          </Fragment>
        ) : (
          <Fragment>
            {/*
                    <div className="chatting_icon chatting_activation">
                       
                        <div className="div_ul">
                            
                        </div>
                        
                    </div>
                    */}
            <div className="chatting_input chatting_border">
              <form
                onSubmit={this.handleSubmit}
                className="textarea_div chatting_border2"
              >
                <div className="textarea_div chatting_border2">
                  <input
                    id="message"
                    ref={"messageinput"}
                    type="text"
                    className="common_input textarea_chatting"
                    value={message}
                    autoComplete={"off"}
                    placeholder="대화내용을 입력해 주세요~"
                    onKeyUp={(e) => {
                      e.keyCode !== 13 && this.sendTyping();
                    }}
                    onChange={this._onMessageChange}
                  />
                  {/*<textarea name="" cols="" rows="" className="common_input textarea_chatting">신의탑 너무 재밋어요!</textarea>*/}
                </div>
              </form>
              <span style={{ cursor: "pointer" }} onClick={this._onSendClick}>
                <em>등록</em>
              </span>
            </div>
          </Fragment>
        )}

        {/*
                <div className="message-input">
                    <form
                        onSubmit={this.handleSubmit}
                        className="message-form"
                    >
                        <input 
                            id="message"
                            ref={"messageinput"}
                            type="text"
                            className="form-control"
                            value={message}
                            autoComplete={'off'}
                            placeholder="type somthing interesting"
                            onKeyUp={e => {
                                e.keyCode !== 13 && this.sendTyping()
                            }}
                            onChange = {
                                ({target})=> {
                                    this.setState({
                                        message: target.value
                                    })
                                }
                            }
                        />
                        <button
                            disabled = { message.length < 1}
                            type="submit"
                            className="send"
                        >
                            send
                        </button>
                    </form>

                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MessageInput));
